export default "__VITE_ASSET__09ef48bd__"